import React, { FC } from "react";

interface IVideoPlayer {
  /**name of the video file, that we want to show */
  filename: string;
  width?: number;
  height?: number;
  thumbnailSource?: string;
}

export const VideoPlayer: FC<IVideoPlayer> = ({
  filename,
  height = 640,
  width = 360,
  thumbnailSource = "",
}) => {
  // const videoUrl = `http://localhost:3001/api/v1/video/${filename}`;
  const videoUrl = `${window.location.origin}/api/v1/video/${filename}`;

  return (
    <div style={{ maxWidth: width, margin: "0 auto" }}>
      <video
        width={width}
        height={height}
        controls
        poster={thumbnailSource}
        // You can also add poster="/path/to/poster.jpg" for a thumbnail
      >
        <source src={videoUrl} type="video/mp4" />
        {/* If you have WebM or Ogg versions, you can fallback: */}
        {/* <source src={`http://localhost:3001/videos/${filename.replace('.mp4', '.webm')}`} type="video/webm" /> */}
        Your browser does not support the video tag.
      </video>
    </div>
  );
};
